var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g({tag:"component",staticClass:"link",class:{
    'link--styled': _vm.hasStyle,
    'link--no-wrap': _vm.isNoWrap,
  },attrs:{"to":_vm.to,"handleClick":_vm.handleClick}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }